export default __webpack_public_path__ + "static/media/Group 849.73dbd2a6.png";